import { render } from "./configure_verification_questions.html?vue&type=template&id=3b9a346e&scoped=true&external"
import script from "./configure_verification_questions.js?vue&type=script&lang=js&external"
export * from "./configure_verification_questions.js?vue&type=script&lang=js&external"

import "./ConfigureVerificationQuestions.vue?vue&type=style&index=0&id=3b9a346e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9a346e"]])

export default __exports__